import { Box, TextFieldProps } from '@material-ui/core';
import React, { useState } from 'react';
import classnames from 'classnames';
import styles from './SGSInputSearch.module.scss';
import { SGSInput } from 'components';

type Props = TextFieldProps & {
    title: string;
    onSearch(value: string);
};

const SGSInputSearch: React.FC<Props> = ({ className, title, onSearch, ...props }) => {
    const [value, setValue] = useState<string>();

    return (
        <Box className={styles.inputSearch}>
            <Box className={styles.inputSearch__titleContainer}>{title}</Box>
            <Box className={styles.inputSearch__inputContainer}>
                <SGSInput
                    fullWidth
                    value={value}
                    className={classnames(styles.inputSearch__input, className)}
                    //InputProps={{ disableUnderline: true }}
                    onChange={(e) => setValue(e.target.value)}
                    onKeyDown={(e) => e.key === 'Enter' && onSearch(value)}
                    {...props}
                />
            </Box>
            <Box className={styles.inputSearch__iconContainer}>
                <Box
                    component="span"
                    className={classnames('fas fa-search', styles.inputSearch__icon)}
                    onClick={() => onSearch(value)}
                ></Box>
            </Box>
        </Box>
    );
};

export default SGSInputSearch;
